module.exports = __webpack_public_path__ + "img/Slider1.9f609567.svg";